class RDFaq {
  constructor(root) {
    this.root = root;
    this.items = [...root.querySelectorAll('.rd-faq__item')];
    this.items.forEach((item) => {
      const trigger = item.querySelector('.rd-faq__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', () => this.toggle(item));
    });
  }

  toggle(item) {
    const trigger = item.querySelector('.rd-faq__trigger');
    const content = item.querySelector('.rd-faq__content');
    const willOpen = !item.classList.contains('is-active');

    this.items.forEach((other) => {
      const otherTrigger = other.querySelector('.rd-faq__trigger');
      const otherContent = other.querySelector('.rd-faq__content');
      other.classList.remove('is-active');
      if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
      if (otherContent) otherContent.hidden = true;
    });

    if (willOpen) {
      item.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
      content.hidden = false;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-rd-faq]').forEach((root) => {
    if (!root.dataset.rdFaqReady) {
      root.dataset.rdFaqReady = 'true';
      new RDFaq(root);
    }
  });
});

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll?.('[data-rd-faq]').forEach((root) => {
    if (!root.dataset.rdFaqReady) {
      root.dataset.rdFaqReady = 'true';
      new RDFaq(root);
    }
  });
});
